import { IconArrowLeft, IconArrowRight, IconLockOpen } from "@tabler/icons-react";
import { useConfirmarProrrateo, useReabrirProrrateo } from "@/features/prorrateo/hooks/use-prorrateo-mutations";
import { Button, Group, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui";

interface Props {
  solicitudId: string;
  confirmado: boolean;
  soloLectura: boolean;
  /** false para Orden de Compra: nada que corregir a mano · oculta "Reabrir". */
  puedeReabrir?: boolean;
  puedeConfirmar: boolean;
  /** Motivo por el que no se puede confirmar · se muestra en el tooltip del botón deshabilitado. */
  motivoNoConfirmable?: string;
  cantidadLineas: number;
  onVolver: () => void;
  /** Etiqueta del botón de volver · default "Regresar a Proveedor" (paso previo típico). */
  labelVolver?: string;
  onConfirmado: () => void;
}

/**
 * Barra de acciones inferior · Volver (siempre) + Reabrir (si confirmado,
 * editable y `puedeReabrir`) + Confirmar (si todavía no confirmado). Cada
 * acción es dispatch a un hook · no se ensucia con queryClient.
 */
export function ProrrateoActions({ solicitudId, confirmado, soloLectura, puedeReabrir = true, puedeConfirmar, motivoNoConfirmable, cantidadLineas, onVolver, labelVolver = "Regresar a Proveedor", onConfirmado }: Props) {
  const confirmar = useConfirmarProrrateo(solicitudId);
  const reabrir = useReabrirProrrateo(solicitudId);

  const handleConfirmar = async () => {
    await confirmar.mutateAsync();
    onConfirmado();
  };

  const botonConfirmar = (
    <Button rightSection={<IconArrowRight size={14} />} disabled={confirmado || cantidadLineas === 0 || !puedeConfirmar} loading={confirmar.isPending} onClick={handleConfirmar}>
      {confirmado ? "Ya confirmado" : "Confirmar y continuar"}
    </Button>
  );

  return (
    <Group justify="space-between" className="mt-1">
      <Button leftSection={<IconArrowLeft size={14} />} onClick={onVolver}>
        {labelVolver}
      </Button>
      <Group gap="xs">
        {confirmado && !soloLectura && puedeReabrir && (
          <Button variant="default" leftSection={<IconLockOpen size={14} />} loading={reabrir.isPending} onClick={() => reabrir.mutate()}>
            Reabrir
          </Button>
        )}
        {!soloLectura &&
          (puedeConfirmar ? (
            botonConfirmar
          ) : (
            <Tooltip>
              <TooltipTrigger asChild>
                <span tabIndex={0}>{botonConfirmar}</span>
              </TooltipTrigger>
              <TooltipContent>{motivoNoConfirmable ?? "La suma del prorrateo no coincide con el subtotal del CFDI"}</TooltipContent>
            </Tooltip>
          ))}
      </Group>
    </Group>
  );
}
